import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

const DesignationSelect = ({ value, onChange }) => {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/designations/listdesignation`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const transformedDesignations = response.data.map((designation) => ({
          value: designation.id,
          label: designation.designation,
        }));
        setDesignations(transformedDesignations);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching designations:", error.message);
        setLoading(false);
      }
    };

    fetchDesignations();
  }, []);


  // Custom styles for the Select component
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f9f9f9', // Apply background color
      borderColor: '#ddd', // Apply border color
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure dropdown appears above other elements
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#666666', // Customize placeholder color
    }),
  };

  return (
    <Select
      options={designations}
      placeholder="Select Designation"
      value={value}
      onChange={onChange}
      isLoading={loading}
      isClearable
      styles={customStyles} // Apply custom styles here
    />
  );
};

export default DesignationSelect;
